<template>
	<div class="newsList" ref="container">
		<div class="content" v-html="listThree"></div>
	</div>
</template>
<script>
	import {
		getZiXun
	} from "@api/store";
	import axios from "axios";
	export default {
		name: "NewsList",
		components: {},
		props: {},
		data: function() {
			const { mid = 0 } = this.$route.query;
			return {
				listThree: "",
				mid: mid,
			};
		},
		mounted: function() {
			if(this.mid==54){
				this.getyun();
			}else{
				this.getQiYe();
			}
		},
		methods: {
			getQiYe() {
				getZiXun().then(res => {
					this.listThree = res.data.desc;
				});
			},
			getyun() {
				var that = this;
				axios.get('http://xlx.funengtuan.com/api/mer_info', {})
				.then(function (res) {
					that.listThree = res.data.data.desc;
				})
			}
		}
	};
</script>
<style>
	.content {
		padding: 10px;
	}

	.content img {
		max-width: 100% !important;
		height: auto !important;
	}
</style>
